import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JsonCacheInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.responseType === 'json') {
            const modifiedReq = req.clone({
                setHeaders: {
                    'Cache-Control': 'no-cache, must-revalidate'
                }
            });
            return next.handle(modifiedReq);
        }

        return next.handle(req);
    }
}
